import { Component, ElementRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { GenericConfirmationModalComponent } from '../../../modal/generic-confirmation-modal/generic-confirmation-modal.component';
import { ImportExportService } from '../../../../shared/import-export.service';
import { LotsService } from '../../../../shared/lots.service';
import { ENTITIES } from '../../../../entities';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-warehouse-fulfilment-bulk-actions',
  templateUrl: './warehouse-fulfilment-bulk-actions.component.html',
  styleUrls: ['./warehouse-fulfilment-bulk-actions.component.css'],
})
export class WarehouseFulfilmentBulkActionsComponent implements OnInit {
  @Input() bulkActionsActive: boolean;

  @Output() onDelete = new Subject<void>();
  @Output() onExport = new Subject<string>();

  @ViewChild('getUpdateAvailable', { static: true }) getUpdateAvailable: ElementRef;
  currentFileUpload: File;

  constructor(
    private dialog: MatDialog,
    public snackBar: MatSnackBar,
    private importExportService: ImportExportService,
    private lotsService: LotsService
  ) {}

  ngOnInit() {}

  delete() {
    const dialogRef = this.dialog.open(GenericConfirmationModalComponent, {
      width: '350px',
      data: 'Deleting fulfilment rows.',
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.onDelete.next();
      } else {
        console.log('Rows not deleted.');
      }
    });
  }

  exportExcel(format: string) {
    this.onExport.next(format);
  }

  importUpdateAvailable() {
    this.getUpdateAvailable.nativeElement.click();
  }

  fileChanged(event) {
    this.currentFileUpload = event.target.files[0];

    this.snackBar.open('Uploading', '')._dismissAfter(3000);

    this.importExportService.uploadFile(this.currentFileUpload, ENTITIES.UPDATE_AVAILABLE, this.lotsService.currentLotId).subscribe(() => {
      this.currentFileUpload = undefined;
    });
  }
}
